import { createContext, useContext } from 'react';

import { type AnalyticsProvider } from './types';

export const AnalyticsContext = createContext<Pick<
  AnalyticsProvider,
  'track' | 'identify'
> | null>(null);

export const useAnalyticsContext = () => {
  const ctx = useContext(AnalyticsContext);

  if (!ctx) {
    throw new Error('useAnalytics must be used inside AnalyticsProvider');
  }

  return ctx;
};
